export enum IbanValidation {
    VALID = 'valid',
    INVALID_IBAN = 'invalidIban',
    INVALID_FORMAT = 'invalidFormat',
}

export class Iban {
    private readonly code: string = '';

    constructor(code: string) {
        this.code = code.replace(/\s/g, '');
    }

    public getCode(): string {
        return this.code;
    }

    public getMaskedIban(): string {
        let ibanCode = this.code;
        const size = ibanCode.length - 5;
        ibanCode = ibanCode.substring(0, 4).padEnd(size, '*') + ibanCode.substring(size);
        ibanCode = ibanCode.replace(/(.{4})(?=.)/g, '$1 ');

        return ibanCode;
    }

    public getStatusValidation(): { status: IbanValidation; message: string } {
        // Source : https://stackoverflow.com/questions/21928083/iban-validation-check

        // prettier-ignore
        const CODE_LENGTHS:Record<string, number> = {
            AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
            CH: 21, CR: 22, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
            FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
            HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
            LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
            MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
            RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
            AL: 28, BY: 28, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25, SV: 28,
            TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
        };

        const code: RegExpMatchArray | null = this.code.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/); // match and capture (1) the country code, (2) the check digits, and (3) the rest

        if (!code) {
            return { status: IbanValidation.INVALID_IBAN, message: "Cet IBAN n'est pas reconnu." };
        }

        if (code[1] && CODE_LENGTHS[code[1]] && this.code.length !== CODE_LENGTHS[code[1]]) {
            return {
                status: IbanValidation.INVALID_FORMAT,
                message: `Le format de votre IBAN n'est pas valide. Ex: ${code[1]!.padEnd(CODE_LENGTHS[code[1]]!, 'x').replace(/(.{4})(?=.)/g, '$1 ')}`,
            };
        }

        // rearrange country code and check digits, and convert chars to ints
        const digits = `${code[3]}${code[1]}${code[2]}`.replace(/[A-Z]/g, (letter) =>
            (letter.charCodeAt(0) - 55).toString(),
        );

        // final check
        return this.mod97(digits) === 1
            ? { status: IbanValidation.VALID, message: '' }
            : { status: IbanValidation.INVALID_IBAN, message: "Cet IBAN n'est pas reconnu." };
    }

    private mod97(digital: number | string) {
        digital = digital.toString();
        let checksum: number | string = digital.slice(0, 2);
        let fragment = '';
        for (let offset = 2; offset < digital.length; offset += 7) {
            fragment = checksum + digital.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }
}
